import Cookies from 'js-cookie';
import React from 'react';

import { createApiConfig, createAxiosInstance } from '@/api';
import {
  AssessmentsApi,
  AuthApi,
  FileUploadApi,
  GradeSheetsApi,
  OrganizationsApi, PopulationDataUploadApi, PopulationsApi, ScoresApi,
  StandardsApi, TokenManagerApi,
} from '@/api/api-client';

export const useAssessmentsApi = () => {
  const axiosInstance = React.useMemo(() => createAxiosInstance(), []);
  const config = createApiConfig();

  const assessmentsApi = React.useMemo(() =>
    new AssessmentsApi(
      config,
      config.basePath,
      axiosInstance,
    ),
    [config, axiosInstance]
  )

  return { assessmentsApi };
};

export const useAuthApi = () => {
  const config = createApiConfig();
  const axiosInstance = React.useMemo(() => createAxiosInstance(), []);

  const authApi = React.useMemo(() =>
      new AuthApi(
        config,
        config.basePath,
        axiosInstance
      ),
    [config, axiosInstance]
  );

  const tokenManagerApi = React.useMemo(() =>
      new TokenManagerApi(
        config,
        config.basePath,
        axiosInstance
      ),
    [config, axiosInstance]
  );

  return { authApi, tokenManagerApi };
};

export const useRefreshAuthApi = () => {
  const config = createApiConfig();
  const refreshToken = Cookies.get('refreshToken');
  const axiosInstance = React.useMemo(() => createAxiosInstance(refreshToken), [refreshToken]);

  const refreshAuthApi = React.useMemo(() =>
      new AuthApi(
        config,
        config.basePath,
        axiosInstance
      ),
    [config, axiosInstance]
  );

  return { refreshAuthApi };
};

export const useFileUploadApi = () => {
  const axiosInstance = React.useMemo(() => createAxiosInstance(), []);
  const config = createApiConfig();

  const fileUploadApi = React.useMemo(() =>
      new FileUploadApi(
        config,
        config.basePath,
        axiosInstance
      ),
    [config, axiosInstance]
  );

  return { fileUploadApi };
};

export const useOrganizationsApi = () => {
  const axiosInstance = React.useMemo(() => createAxiosInstance(), []);
  const config = createApiConfig();

  const organizationsApi = React.useMemo(() =>
      new OrganizationsApi(
        config,
        config.basePath,
        axiosInstance
      ),
    [config, axiosInstance]
  );

  return { organizationsApi };
};

export const useStandardsApi = () => {
  const axiosInstance = React.useMemo(() => createAxiosInstance(), []);
  const config = createApiConfig();

  const standardsApi = React.useMemo(() =>
      new StandardsApi(
        config,
        config.basePath,
        axiosInstance
      ),
    [config, axiosInstance]
  );

  return { standardsApi };
};

export const useGradeSheetsApi = () => {
  const axiosInstance = React.useMemo(() => createAxiosInstance(), []);
  const config = createApiConfig();

  const gradeSheetsApi = React.useMemo(() =>
      new GradeSheetsApi(
        config,
        config.basePath,
        axiosInstance
      ),
    [config, axiosInstance]
  );

  return { gradeSheetsApi };
};

export const useScoresApi = () => {
  const axiosInstance = React.useMemo(() => createAxiosInstance(), []);
  const config = createApiConfig();

  const scoresApi = React.useMemo(() =>
      new ScoresApi(
        config,
        config.basePath,
        axiosInstance
      ),
    [config, axiosInstance]
  );

  return { scoresApi };
};

export const usePopulationDataUploadApi = () => {
  const axiosInstance = React.useMemo(() => createAxiosInstance(), []);
  const config = createApiConfig();

  const populationDataUploadApi = React.useMemo(() =>
      new PopulationDataUploadApi(
        config,
        config.basePath,
        axiosInstance
      ),
    [config, axiosInstance]
  );

  return { populationDataUploadApi };
};

export const usePopulationsApi = () => {
  const axiosInstance = React.useMemo(() => createAxiosInstance(), []);
  const config = createApiConfig();

  const populationsApi = React.useMemo(() =>
      new PopulationsApi(
        config,
        config.basePath,
        axiosInstance
      ),
    [config, axiosInstance]
  );

  return { populationsApi };
};